module.exports = __webpack_public_path__ + "img/client-pinta.a3712b9e.png";